const modalEditPhotoFormEquip = {
  title: 'Edit Equipment Photo'
};

export default modalEditPhotoFormEquip;
